import { TEMPLATE_LINK } from '@/constants/link';

export const BATCH_UPLOAD_MAP = {
  profile_photo: {
    label: '批量上传头像',
    value: 'profile_photo',
    uploadText: '上传ZIP文件',
    accept: '.zip',
    size: 50 * 1024 * 1024,
    biz_type: 'USER_IMPORT_PROFILE',
    templateTip: '您需要按照标准格式，上传ZIP格式的文件，小于50MB',
  },
  personal_info: {
    label: '批量上传简介',
    value: 'personal_info',
    uploadText: '上传CSV文件',
    accept: '.csv',
    size: 10 * 1024 * 1024,
    biz_type: 'USER_IMPORT_PROFILE',
    templateTip: '您需要按照标准格式，上传CSV格式的文件，小于10MB',
    templateUrl: TEMPLATE_LINK.batch_upload_personal_info,
  },
  wecom_qrcode: {
    label: '批量上传企微二维码',
    value: 'wecom_qrcode',
    uploadText: '上传ZIP文件',
    accept: '.zip',
    size: 50 * 1024 * 1024,
    biz_type: 'USER_IMPORT_PROFILE',
    templateTip: '您需要按照标准格式，上传ZIP格式的文件，小于50MB',
  },
};

// 运营固定角色
export const OPERATION_ROLE_LIST = [100, 101, 102, 103, 108, 114, 116, 117, 118];

// 运营按钮权限
export const ROLE_PERM_MAP = {
  101: {
    delete: 102,
  }, // 管理员
  103: {
    delete: 103,
  }, // 财务人员 超级管理员可编辑删除财务人员
  102: {
    delete: 104,
  }, // 报表分析员
  114: {
    delete: 105,
  }, // 运营管理员
  108: {
    delete: 106,
  }, // 运营人员
  116: {
    delete: 11008,
  }, // 设计师
  117: {
    delete: 11009,
  }, // 超管和管理员
  118: {
    delete: 130,
  }, // 观察者
  100: {
    delete: null,
  }, // 超级管理员
};

// 员工类型
export const EMPLOYEE_TYPE = {
  inner: 1,
  external: 2,
  sub: 3,
};

export const EMPLOYEE_TYPE_MAP = {
  1: '内部员工',
  2: '外部员工',
  3: '子帐号员工',
};

// 手机号匹配状态
export const MOBILE_MATCH_STATUS_MAP_MAP = {
  0: '未匹配',
  1: '匹配',
};

// 员工状态
export const EMPLOYEE_STATUS = {
  incumbent: 0,
  departure: 1,
  unactive: 2,
};

// 员工状态名称
export const EMPLOYEE_STATUS_NAME = {
  0: '在职',
  1: '离职',
  2: '未激活',
};

export const RES_CODE = {
  CHECK_QQ_OPENID: 219,                     // 需要验证qq
  CHECK_WECHAT_OPENID: 220,                 // 需要验证wx
};
